import type { ReactNode } from 'react';

// Lightweight typographic primitives so blog posts get consistent
// spacing/typography without pulling in @tailwindcss/typography.

export function H2({ id, children }: { id?: string; children: ReactNode }) {
  return (
    <h2 id={id} className="mt-10 mb-3 text-2xl font-semibold tracking-tight scroll-mt-24">
      {children}
    </h2>
  );
}

export function H3({ id, children }: { id?: string; children: ReactNode }) {
  return (
    <h3 id={id} className="mt-6 mb-2 text-lg font-semibold scroll-mt-24">
      {children}
    </h3>
  );
}

export function P({ children }: { children: ReactNode }) {
  return <p className="my-4 text-foreground/90 leading-relaxed">{children}</p>;
}

export function UL({ children }: { children: ReactNode }) {
  return <ul className="my-4 list-disc pl-6 space-y-2 text-foreground/90">{children}</ul>;
}

export function OL({ children }: { children: ReactNode }) {
  return <ol className="my-4 list-decimal pl-6 space-y-2 text-foreground/90">{children}</ol>;
}

export function Callout({ children }: { children: ReactNode }) {
  return (
    <aside className="my-6 rounded-md border border-primary/30 bg-primary/5 px-4 py-3 text-sm text-foreground/90">
      {children}
    </aside>
  );
}

export function Pull({ children }: { children: ReactNode }) {
  return (
    <blockquote className="my-6 border-l-4 border-primary pl-4 text-lg font-medium text-foreground/95 italic">
      {children}
    </blockquote>
  );
}
